import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CryptoIcon from './CryptoIcon';
import { redOrGreen } from './styles';
import { renderMoney } from './money-utils';
import accounting from 'accounting';

const CryptoTableDataCell = styled.td`
  padding: 2px 5px !important;
`;

const CompactTable = styled.table`
  position: relative;
  background: #fff;
  padding: 10px;
  margin: 10px 0;
`;

const TopRow = styled.tr`
  border-bottom: 1px solid #4cb4a4;
  width; 100%;
`;

const FlexCell = styled.td`
  display: flex;
  align-items: center;
`;

const Row = styled.tr`
  margin: 5px 0 0 0;
`;

const Rank = styled.span`
  position: absolute;
  right: -5px;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;

  & > span {
    font-size: 10px;
    font-weight: bold;
    color: #fff;
    text-transform: uppercase;
    text-align: center;
    line-height: 20px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    width: 100px;
    display: block;
    background: #79a70a;
    background: linear-gradient(#9bc90d 0%, #79a70a 100%);
    box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
    position: absolute;
    top: 19px;
    right: -21px;
  }

  & > span::before {
    content: '';
    position: absolute;
    left: 0px;
    top: 100%;
    z-index: -1;
    border-left: 3px solid #79a70a;
    border-right: 3px solid transparent;
    border-bottom: 3px solid transparent;
    border-top: 3px solid #79a70a;
  }

  & > span::after {
    content: '';
    position: absolute;
    right: 0px;
    top: 100%;
    z-index: -1;
    border-left: 3px solid transparent;
    border-right: 3px solid #79a70a;
    border-bottom: 3px solid transparent;
    border-top: 3px solid #79a70a;
  }
`;

export default function ListItemTable({ currency, selectedFiatCurrency }) {
  return (
    <CompactTable currency={currency}>
      <tbody>
        <TopRow>
          <FlexCell>
            <Rank>
              <span>Rank {currency.rank}</span>
            </Rank>
            <CryptoIcon symbol={currency.symbol} />
            <strong>{currency.symbol}</strong>
          </FlexCell>
          <CryptoTableDataCell>
            <strong>{currency.name}</strong>
          </CryptoTableDataCell>
          <CryptoTableDataCell />
        </TopRow>
        <Row>
          <CryptoTableDataCell style={{ textAlign: 'center' }}>
            <span style={redOrGreen(currency.percent_change_1h)}>
              <strong>1h</strong>
              <br /> {currency.percent_change_1h}%
            </span>
          </CryptoTableDataCell>
          <CryptoTableDataCell style={{ textAlign: 'center' }}>
            <span style={redOrGreen(currency.percent_change_24h)}>
              <strong>24h</strong>
              <br /> {currency.percent_change_24h}%
            </span>
          </CryptoTableDataCell>
          <CryptoTableDataCell style={{ textAlign: 'center' }}>
            <span style={redOrGreen(currency.percent_change_7d)}>
              <strong>7d</strong>
              <br /> {currency.percent_change_7d}%
            </span>
          </CryptoTableDataCell>
        </Row>
        <Row>
          <CryptoTableDataCell colSpan={3}>
            <strong>Total Supply:</strong>{' '}
            {accounting.format(currency.total_supply)}
          </CryptoTableDataCell>
        </Row>
        <Row>
          <CryptoTableDataCell colSpan={3}>
            <strong>Market cap:</strong>{' '}
            {renderMoney(currency.market_cap_usd, selectedFiatCurrency)}
          </CryptoTableDataCell>
        </Row>
        <Row>
          <CryptoTableDataCell colSpan={3}>
            <strong>Price:</strong>{' '}
            {renderMoney(currency.price_usd, selectedFiatCurrency)}
          </CryptoTableDataCell>
        </Row>
      </tbody>
    </CompactTable>
  );
}

ListItemTable.propTypes = {
  currency: PropTypes.object,
  selectedFiatCurrency: PropTypes.string,
};
